import { Component, OnInit, ViewChild } from '@angular/core';
import { AuthService } from '../_services/auth.service';
import { Globals } from '../_globals';
import { DynamicFormComponent } from '../_dynamic_form/containers/dynamic_form/dynamic-form.component';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { environment } from '../../environments/environment';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationService } from '../_services/notification.service';
import { FoodToGoService } from '../_services/food-to-go.service';
import { ScheduleService } from '../_services/schedule.service';
import { CookieService } from 'ngx-cookie-service';
import { TreeNode, ConfirmationService } from 'primeng/api';
import { ObjectFilterPipe } from '../_pipes/object-filter.pipe';
import { ImagesService } from '../_services/images.service';

@Component({
  selector: 'app-food-to-go-categories',
  templateUrl: './food-to-go-categories.component.html',
  styleUrls: ['./food-to-go-categories.component.css'],
})
export class FoodToGoCategoriesComponent implements OnInit {
  @ViewChild(DynamicFormComponent) filterForm: DynamicFormComponent;

  categories: any[] = [];
  selectedCategory = {
    label: 'No Category Selected',
    id: null,
    image: null,
    data: { id: null, image: null },
  };
  selectedCategoryNode: any;

  cookieStore: any;
  storeId: any;

  createCategoryModal = false;
  createCategoryForm: FormGroup;
  creatingSubCategory = false;
  errMsgs: any[] = [];

  daysOfWeek: DayOfWeek[] = this.globals.daysOfWeek;
  dayHours: DayHours[] = this.globals.dayHours;
  hourMins: HourMins[] = this.globals.hourMins;

  catSchedule = [];

  chooseFromImageBank = false;
  uploadNew = false;

  displayCategories: TreeNode[] = [];

  editCategoryForm: FormGroup;
  scheduleForm: FormGroup;

  scheduleModal = false;

  addMediaModal = false;
  imagesArray: any[] = [];
  selectedImage: any;
  imageBase64: any;

  constructor(
    public loader: LoadingBarService,
    public activatedRoute: ActivatedRoute,
    public router: Router,
    public globals: Globals,
    public fb: FormBuilder,
    public notificationService: NotificationService,
    public _foodToGoService: FoodToGoService,
    public _scheduleService: ScheduleService,
    public cookieService: CookieService,
    public objectFilter: ObjectFilterPipe,
    public _imagesService: ImagesService,
    public confirmationService: ConfirmationService
  ) {
    // Handle Store Cookies
    const hasCurrentStore = cookieService.check('currentStore');
    if (hasCurrentStore) {
      this.cookieStore = JSON.parse(cookieService.get('currentStore'));
      this.storeId = this.cookieStore.id;
    } else {
      this.router.navigate(['/' + this.globals.user.routeRole + '/select-store']);
    }

    this.createCategoryForm = fb.group({
      name: new FormControl('', [Validators.required]),
      description: new FormControl(),
    });

    this.editCategoryForm = fb.group({
      name: new FormControl(),
      description: new FormControl(),
      enabled: new FormControl(),
    });

    this.scheduleForm = fb.group({
      days: [],
      startTimeHour: 0,
      startTimeMinute: 0,
      endTimeHour: 0,
      endTimeMinute: 0,
    });
  }

  ngOnInit() {
    this.getAllCategories();
  }

  public onScheduleFormSubmit() {
    const values = this.scheduleForm.value;
    // console.log('Form Values - ', values);

    if (!values.days || !values.days.length || !values.startTimeHour.value || !values.startTimeMinute.value || !values.endTimeHour.value || !values.endTimeMinute.value) {
      this.notificationService.notify('danger', 'Error', 'Please complete all fields', 'top', 'right');
    } else {
      this.toggleScheduleModal();
      values.days.forEach((element) => {
        const obj = {
          dayOfWeek: element.value,
          startTimeHour: values.startTimeHour.value,
          startTimeMinute: values.startTimeMinute.value,
          endTimeHour: values.endTimeHour.value,
          endTimeMinute: values.endTimeMinute.value,
        };
        this._scheduleService.createFTGCategorySchedule(this.selectedCategoryNode.id, obj).subscribe((data: any) => {
          this.scheduleForm.reset();
          this.getFTGCategorySchedules(this.selectedCategoryNode.id);
          this.notificationService.notify('success', 'Schedule Added', 'New Schedule successfully added', 'top', 'right');
        });
      });
    }
  }

  public toggleScheduleModal() {
    this.scheduleModal = !this.scheduleModal;
  }

  public getAllCategories() {
    this.displayCategories = [];
    this._foodToGoService.getItemCategoriesByStoreId(this.storeId).subscribe((data: any) => {
      // console.log('Categories - ', data);
      this.categories = data;
      this.filterRootItemCategories(null);
    });
  }

  public populateTreeMenu(array) {
    const filteredArray = array;
    filteredArray.forEach((element) => {
      // console.log(element);
      const treeNodeObject = {
        label: element.name,
        data: element,
        id: element.id,
        parent: element.parentFoodToGoItemCategoryId,
        expandedIcon: 'fa fa-folder-open',
        collapsedIcon: 'fa fa-folder',
        leaf: false,
        image: null,
        imageObj: null,
      };
      if (element.image !== null) {
        treeNodeObject.imageObj = element.image;
        treeNodeObject.image = environment.dcSpacesUrl + 'images/' + this.storeId + '/' + element.image.name;
      }
      this.displayCategories.push(treeNodeObject);
    });
  }

  public filterRootItemCategories(categoryId) {
    const catId = categoryId;
    const filteredCats = this.objectFilter.transform(this.categories, 'parentFoodToGoItemCategoryId', catId);
    this.populateTreeMenu(filteredCats);
  }

  public loadNode(event) {
    if (event.node) {
      const parentId = event.node.data.id;
      const children = this.objectFilter.transform(this.categories, 'parentFoodToGoItemCategoryId', parentId);
      children.forEach((element) => {
        element.label = element.name;
        element.data = element;
        element.parent = element.parentFoodToGoItemCategoryId;
        element.expandedIcon = 'fa fa-folder-open';
        element.collapsedIcon = 'fa fa-folder';
        element.leaf = false;
        if (element.image !== null) {
          element.imageObj = element.image;
          element.image = environment.dcSpacesUrl + 'images/' + this.storeId + '/' + element.image.name;
        }
      });
      event.node.children = children;
    }
  }

  public getFTGCategorySchedules(id) {
    this._scheduleService.getFTGCategorySchedules(id).subscribe((data: any) => {
      // console.log('Category Schediule - ', data);
      this.catSchedule = data;
    });
  }

  public nodeSelect(event) {
    // console.log('EVENT NODE - ', event.node.data);
    this.selectedCategoryNode = event.node.data;
    this.catSchedule = [];

    this.getFTGCategorySchedules(this.selectedCategoryNode.id);

    this.editCategoryForm.reset();
    this.editCategoryForm.setValue({
      name: event.node.data.name,
      description: event.node.data.description,
      enabled: event.node.data.enabled,
    });
  }

  public toggleCreateCategoryModal() {
    this.createCategoryModal = !this.createCategoryModal;
  }

  public toggleCreateSubCategoryModal() {
    this.creatingSubCategory = !this.creatingSubCategory;
    this.createCategoryModal = !this.createCategoryModal;
  }

  public onCreateCategoryFormSubmit() {
    const values = this.createCategoryForm.value;
    let body;
    if (this.creatingSubCategory) {
      body = {
        name: values.name,
        description: values.name,
        parentFoodToGoItemCategoryId: this.selectedCategory.data.id,
        storeId: this.storeId,
      };
    } else {
      body = {
        name: values.name,
        description: values.name,
        parentFoodToGoItemCategoryId: null,
        storeId: this.storeId,
      };
    }
    this._foodToGoService.createCategory(body).subscribe((data: any) => {
      console.log(data);
      this.createCategoryForm.reset();
      if (this.creatingSubCategory) {
        this.toggleCreateSubCategoryModal();
      } else {
        this.toggleCreateCategoryModal();
      }
      this.getAllCategories();
      this.notificationService.notify('success', 'Category Created', 'New Category has successfully been created', 'top', 'right');
    });
  }

  public onEditCategoryFormSubmit() {
    const values = this.editCategoryForm.value;
    values.id = this.selectedCategory.id;
    this._foodToGoService.editCategory(values).subscribe((data: any) => {
      // console.log(data);
      this.getAllCategories();
      // this.selectedCategory = { label: 'No Category Selected', id: null, image: null, data: { id: null, image: null } };
      this.notificationService.notify('success', 'Category Updated', 'Category has successfully been updated', 'top', 'right');
    });
  }

  // Add Media Modal
  public toggleAddMediaModal() {
    this.addMediaModal = !this.addMediaModal;
    this.getImages(this.storeId);
  }

  // Get All Images
  public getImages(id) {
    this.imagesArray = [];
    this._imagesService.getAllStoreImages(id).subscribe((data: any) => {
      // console.log(data);
      data.forEach((element) => {
        const obj = {
          imageUrl: environment.dcSpacesUrl + 'images/' + this.storeId + '/' + element.name,
          src: environment.dcSpacesUrl + 'images/' + this.storeId + '/' + element.name,
          thumb: environment.dcSpacesUrl + 'images/' + this.storeId + '/' + element.name,
          imageData: element,
        };
        this.imagesArray.push(obj);
      });
    });
  }

  public selectImageBankImage(image) {
    // console.log('selectedCategory', this.selectedCategory);
    // console.log('Image to attach - ', image);
    this._imagesService.addImageToFoodToGoCategory(this.selectedCategory.id, image.imageData.id).subscribe((data: any) => {
      // console.log('Attach Image Response - ', data);
      if (this.selectedCategoryNode.parentFoodToGoItemCategoryId === null) {
        this.selectedCategoryNode.image = data;
      } else {
        this.selectedCategoryNode.imageObj = data;
      }
      this.selectedCategory.image = environment.dcSpacesUrl + 'images/' + this.storeId + '/' + data.name;
      this.toggleAddMediaModal();
      this.notificationService.notify('success', 'Image Added', 'Category Image has successfully been updated', 'top', 'right');
    });
  }

  // Uploading
  public onFileChange(event) {
    for (let i = 0; i < event.target.files.length; i++) {
      const file: File = event.target.files[i];
      const myReader: FileReader = new FileReader();
      const that = this;
      myReader.onloadend = function (loadEvent: any) {
        const fileObj = {
          fileName: event.target.files[i].name,
          imageBase64: loadEvent.target.result,
          itemCategoryId: that.selectedCategory.id,
          itemFeaturedItemId: null,
          itemImageItemId: null,
          storeFeaturedImageStoreId: null,
          storeId: that.storeId,
          storeLogoStoreId: null,
        };
        that.imageBase64 = fileObj;
        that.uploadImage(fileObj);
      };
      myReader.readAsDataURL(file);
    }
  }

  public uploadImage(fileObj) {
    this._imagesService.uploadImageToImageBank(fileObj).subscribe((data: any) => {
      this.imagesArray = [];
      this.getImages(this.storeId);
      this.selectedCategory.image = environment.dcSpacesUrl + 'images/' + this.storeId + '/' + data.name;
      this.toggleAddMediaModal();
      this.notificationService.notify('success', 'Image Uploaded', 'Image Successfully Uploaded', 'top', 'right');
    });
  }

  public deleteSchedule(timeslot) {
    this.confirmationService.confirm({
      message: 'Are you sure that you want to delete this schedule?',
      accept: () => {
        this.performDeleteSlot(timeslot);
      },
    });
  }

  performDeleteSlot(timeslot) {
    // Actual logic to perform a confirmation
    this._scheduleService.deleteSchedule(timeslot.id).subscribe((data: any) => {
      // console.log(data);
      this.notificationService.notify('success', 'Schedule Deleted', 'Schedule has successfully been deleted', 'top', 'right');

      this.getFTGCategorySchedules(this.selectedCategoryNode.id);
    });
  }

  public deleteAllTimeslot() {
    this.confirmationService.confirm({
      message: 'Are you sure that you want to delete all timeslots?',
      accept: () => {
        this.catSchedule.forEach((timeslot) => {
          this.performDeleteSlot(timeslot);
        });
      },
    });
  }

  public deleteCategory(category) {
    // console.log('delete category', category);
    this.confirmationService.confirm({
      message: 'Are you sure that you want to remove the ' + category.name + ' category',
      accept: () => {
        this._foodToGoService.deleteCategory(category.id).subscribe((data: any) => {
          this.getAllCategories();
          this.notificationService.notify('success', 'Category Removed', 'The Category has successfully been removed', 'top', 'right');
        });
      },
    });
  }

  public removeImage(type) {
    if (type === 'parent') {
      const body = {
        imageId: this.selectedCategoryNode.image.id,
        itemCategoryId: this.selectedCategoryNode.id,
      };
      this.confirmationService.confirm({
        message: 'Are you sure that you want to remove category image? It will not be deleted from Image bank.',
        accept: () => {
          this._imagesService.removeImageLink(body).subscribe((data: any) => {
            // console.log(data);
            this.selectedCategory = {
              label: 'No Category Selected',
              id: null,
              image: null,
              data: { id: null, image: null },
            };
            this.getAllCategories();
          });
        },
      });
    } else {
      const body = {
        imageId: this.selectedCategoryNode.imageObj.id,
        itemCategoryId: this.selectedCategoryNode.id,
      };
      this.confirmationService.confirm({
        message: 'Are you sure that you want to remove category image? It will not be deleted from Image bank.',
        accept: () => {
          this._imagesService.removeImageLink(body).subscribe((data: any) => {
            // console.log(data);
            this.selectedCategory = {
              label: 'No Category Selected',
              id: null,
              image: null,
              data: { id: null, image: null },
            };
            this.getAllCategories();
          });
        },
      });
    }
  }
}

interface DayOfWeek {
  name: String;
  value: Number;
}

interface DayHours {
  name: String;
  value: String;
}

interface HourMins {
  value: String;
}



// WEBPACK FOOTER //
// ./src/app/food-to-go-categories/food-to-go-categories.component.ts